<template>
	<div class="input__container">
		<span class="input__icon">
			<slot></slot>
		</span>
	</div>
</template>

<script>
export default {
	name: 'FilterViewButton'
}
</script>

<style scoped lang="scss">
.tab--active .input__icon {
	background-color: $colorPrimary2;
	svg {
		fill: #2a3e61;
	}
}
.input {
	&__container {
		border: 0;
		background: $colorWhite;
	}
	&__icon {
		margin: 0 5px;
		display: flex;
		justify-content: center;
		align-items: center;
		transition: all 0.3s ease;
		box-sizing: border-box;
		height: $input-field-height;
		width: $input-field-height;
		border: 1px solid $colorPrimary4;
		border-radius: 5px;
		background-color: $colorWhite;
		svg {
			width: 24px;
			height: 24px;
			fill: $colorPrimary6;
		}
		&:after {
			content: '';
			display: block;
		}
	}
	&__title {
		align-items: center;
		display: flex;
		color: $colorPrimary;
		font-size: 20px;
		line-height: 26px;
	}
}
</style>
